import React, { useState } from "react";

function Profile() {
  const [formData, setFormData] = useState({
    fullName: "Shine",
    email: "shine@example.com",
    phone: "123-456-7890",
    address: "Marthandam, Tamil Nadu - 629165",  // Fixed Address
    city: "Marthandam",
    state: "Tamil Nadu",
    pincode: "629165",
    role: "Admin", // Role is frozen and non-editable
    profilePicture: null,
  });

  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, profilePicture: URL.createObjectURL(file) });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Simulate API Call
    setTimeout(() => {
      setSuccessMessage("Profile updated successfully! ✅");
    }, 500);
  };

  return (
    <div className="max-w-2xl mx-auto mt-10 p-6 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold mb-4">Profile</h2>

      {/* Success Message */}
      {successMessage && (
        <div className="mb-4 p-3 text-green-700 bg-green-100 rounded-md">
          {successMessage}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Profile Picture Upload */}
        <div className="flex items-center space-x-4">
          <div className="w-20 h-20 rounded-full overflow-hidden border">
            {formData.profilePicture ? (
              <img src={formData.profilePicture} alt="Profile" className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full flex items-center justify-center bg-gray-200 text-gray-600">
                No Image
              </div>
            )}
          </div>
          <input type="file" accept="image/*" onChange={handleFileChange} className="px-4 py-2 border rounded-md" />
        </div>

        {/* Full Name */}
        <div>
          <label className="block text-gray-700 font-medium">Full Name</label>
          <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} className="w-full px-4 py-2 border rounded-md" required />
        </div>

        {/* Email (Read-Only) */}
        <div>
          <label className="block text-gray-700 font-medium">Email</label>
          <input type="email" name="email" value={formData.email} className="w-full px-4 py-2 border rounded-md bg-gray-100" readOnly />
        </div>

        {/* Phone Number */}
        <div>
          <label className="block text-gray-700 font-medium">Phone</label>
          <input type="text" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border rounded-md" pattern="[0-9]{10}" required />
        </div>

        {/* Address (Frozen) */}
        <div>
          <label className="block text-gray-700 font-medium">Address</label>
          <input type="text" name="address" value={formData.address} className="w-full px-4 py-2 border rounded-md bg-gray-100" readOnly />
        </div>

        {/* City & State (Frozen) */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-gray-700 font-medium">City</label>
            <input type="text" name="city" value={formData.city} className="w-full px-4 py-2 border rounded-md bg-gray-100" readOnly />
          </div>
          <div>
            <label className="block text-gray-700 font-medium">State</label>
            <input type="text" name="state" value={formData.state} className="w-full px-4 py-2 border rounded-md bg-gray-100" readOnly />
          </div>
        </div>

        {/* Pincode (Frozen) */}
        <div>
          <label className="block text-gray-700 font-medium">Pincode</label>
          <input type="text" name="pincode" value={formData.pincode} className="w-full px-4 py-2 border rounded-md bg-gray-100" readOnly />
        </div>

        {/* Role (Frozen) */}
        <div>
          <label className="block text-gray-700 font-medium">Role</label>
          <input type="text" name="role" value={formData.role} className="w-full px-4 py-2 border rounded-md bg-gray-100" readOnly />
        </div>

        {/* Save Button */}
        <button type="submit" className="w-full py-2 bg-blue-600 text-white rounded-md hover:bg-blue-500">
          Update Profile
        </button>
      </form>
    </div>
  );
}

export default Profile;